import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogActions, DialogContent } from '@material-ui/core'
import { hideOnCloseMessageCall, selectOnCloseMessageCall } from '../../reducers/uiSlice'
import { Button } from '../Kit/Buttons'
import { Label } from '../Kit/Label'
import { useTranslation } from 'react-i18next'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { useEvent } from '../../hooks/useEvent'

const CloseCallDialog = () => {
  const { close } = useEvent()
  const { postHogTrackEvent } = usePostHogAnalytics()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const closeCallMessageIsVisible = useSelector(selectOnCloseMessageCall)

  const handleCancel = () => {
    postHogTrackEvent('event-click-cancel-button-close')
    dispatch(hideOnCloseMessageCall())

    // Esto posiblemente no se usa para nada.
    // history.pushState(CallStates.IN_CALL_STATE, CallStates.IN_CALL_STATE)
  }

  const handleConfirm = () => {
    dispatch(hideOnCloseMessageCall())
    close('USER CLOSED EVENT')
  }

  return (
    <CloseCallDialog.Container data-test="close-call-container" open={closeCallMessageIsVisible}>
      <CloseCallDialog.Content data-test="close-call-content">
        {t('dialogs.content')}
      </CloseCallDialog.Content>
      <CloseCallDialog.Actions data-test="close-call-actions">
        <CloseCallDialog.Confirm
          variant="contained"
          id="close-call-confirm-button"
          data-test="close-call-confirm"
          onClick={handleConfirm}
        >
          {t('dialogs.confirm').toUpperCase()}
        </CloseCallDialog.Confirm>
        <CloseCallDialog.Cancel
          id="event-click-cancel-button-close"
          data-test="event-click-cancel-button-close"
          style={{ marginLeft: 0 }}
          onClick={handleCancel}
        >
          {t('dialogs.cancel')}
        </CloseCallDialog.Cancel>
      </CloseCallDialog.Actions>
    </CloseCallDialog.Container>
  )
}

CloseCallDialog.Container = styled(Dialog)`
  .MuiDialog-paper {
    font-size: 0.9em;
    align-items: center;
    max-width: 271px;
    border-radius: 8px;
  }
`
CloseCallDialog.Content = styled(DialogContent)`
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.2px;

  &.MuiDialogContent-root {
    padding: 2.5em 1.7em 1em 1.7em;
  }
`
CloseCallDialog.Actions = styled(DialogActions)`
  flex-direction: column;
  padding-bottom: 3em;
`
CloseCallDialog.Confirm = styled(Button)`
  margin-bottom: 2.2em;
  width: 139px;
`
CloseCallDialog.Cancel = styled(Label)`
  font-weight: 500;
  font-size: 10px;
  line-height: 1px;
  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;
`

export { CloseCallDialog }
